export enum Appearance {
  Primary = 'primary',
  Link = 'link',
  LinkWithIcon = 'linkWithIcon',
  Funky = 'funky',
  Icon = 'icon',
  PrimaryWithIcon = 'primaryWithIcon',
  PrimaryWithIconCollapsible = 'primaryWithIconCollapsible',
}
